/**
 * Checks if a card number starts with an exempt BIN prefix.
 * Exempt BINs are provided via the REACT_APP_OPTIONAL_CVV_EXPIRY_BINS environment variable
 * as a comma-separated list of 6-8 digit BIN prefixes.
 *
 * Cards with exempt BINs do not require CVV and expiry date fields.
 *
 * @param {string} cardNumber - The card number to check
 * @returns {boolean} - True if the card number starts with an exempt BIN
 */
export const isExemptBin = cardNumber => {
  const exemptBinsEnv = process.env.REACT_APP_OPTIONAL_CVV_EXPIRY_BINS || '';

  if (!exemptBinsEnv || !cardNumber) {
    return false;
  }

  const cleanCardNumber = cardNumber.replace(/[\s-]/g, '');
  const exemptBins = exemptBinsEnv.split(',').map(bin => bin.trim());

  return exemptBins.some(
    bin => bin.length >= 6 && bin.length <= 8 && cleanCardNumber.startsWith(bin)
  );
};
